import { Label } from "reactstrap";
import "../assets/style/SearchBox.css";
import React, { useState } from "react";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { YearCalendar } from '@mui/x-date-pickers';
import IconButton from '@mui/material/IconButton';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';

const YearPicker = (props: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleYearChange = (year: moment.Moment | null) => {
    props.changeFun(year ? year : null, props?.valueName);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'year-calendar-popover' : undefined;

  return (
    <div style={{width: '100%'}}>
      <TextField
        id="standard-basic"
        autoComplete="off"
        name={props?.valueName}
        label={props.label}
        variant="standard"
        sx={{
          minWidth: '95%',
          '& .MuiFormLabel-asterisk': {
              color: 'red',
          },
        }}
        size="small"
        InputLabelProps={{
            style: { fontSize: '13px' }
        }}
        value={props?.formValue ? props?.formValue : ""}
        onClick={handleClick}
        inputProps={{
          readOnly: props.readOnly,
          "aria-autocomplete": 'none'
        }}
        InputProps={{
          endAdornment: (
            <IconButton onClick={handleClick} style={{padding: 0}}>
              <CalendarMonthIcon fontSize="small" />
            </IconButton>
          ),
        }}

      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DemoContainer components={["DatePicker"]}>
            <YearCalendar 
              minDate={moment("2019-01-01")}
              maxDate={moment()}
              onChange={handleYearChange}
              yearsPerRow={4}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: '#829ED1', 
                  color: '#fff', 
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </Popover>
    </div>
  );
};

export default YearPicker;
